import React, { useContext, useState } from 'react';
import { useFetch } from '../api/useFetch';
import { useUserContext } from './user_context';

export const ItemContext = React.createContext();


export const ItemProvider = ({ children }) => {


    const { btoken, stoken } = useUserContext();


    let itemData = { btoken };
    let itemCategoryPayload = { btoken, stoken };

    // GET ITEMS 

    const {
        loading: itemLoading, data: allItems, fetchData: getItemData
    } = useFetch('/getItems', itemData);

    // GET ITEM CATEGORIES 

    const {
        loading: itemCategoryLoading, data: itemCategoryData, fetchData: getItemCategoryData
    } = useFetch('/getItemCategories', itemCategoryPayload);

    // GET SERVICES 
    const {
        loading: serviceLoading, data: allServices, fetchData: getServiceData
    } = useFetch('/getServices', itemData);

    // Sales Type Function
    const [type, settype] = useState('item');

    function changeType(e) {
        settype(e);
    }
    // Sales Type Function


    const [showAddItem, setShowAddItem] = useState(false);
    const CloseAddItem = () => setShowAddItem(false);
    const openAddItem = () => setShowAddItem(true);

    const [showEditItem, setShowEditItem] = useState(false);
    const CloseEditItem = () => setShowEditItem(false);
    const openEditItem = () => setShowEditItem(true);

    const [showAddItemCategory, setShowAddItemCategory] = useState(false);
    const CloseAddItemCategory = () => setShowAddItemCategory(false);
    const openAddItemCategory = () => {
        CloseAddItem();
        setShowAddItemCategory(true);
    };


    return (
        <ItemContext.Provider value={{

            showAddItem, CloseAddItem, openAddItem,
            showEditItem, CloseEditItem, openEditItem,

            showAddItemCategory, CloseAddItemCategory, openAddItemCategory,

            itemLoading, allItems, getItemData,
            itemCategoryLoading, itemCategoryData, getItemCategoryData,

            serviceLoading, allServices, getServiceData,

            changeType, type,

        }}>
            {children}
        </ItemContext.Provider>
    );
};

// make sure use
export const useItemContext = () => {
    return useContext(ItemContext);
};
